// JavaScript source code
/* eslint-disable */
import React from 'react';
import {
    TextField,
    Datagrid,
    Filter,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    TextInput as RATextInput,
    SimpleShowLayout,
} from 'react-admin';
import { EditToolbar } from '../layout/EditToolbar';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { SwList } from '../lib/SwList';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';
import { useAzureADGroups } from '../msal/useAzureADGroups';

//Validation test
export const validateStaticDataWithCode = (values) => {
    const errors = {};
    if (!values.Title) {
        errors.Title = ['Title is required'];
    }
    //if (!values.description) {
    //    errors.description = ['Description is required'];
    //}
    //} else if (!values.id) {
    //errors.id = ['Identifier is required'];
    //}
    return errors;
};

const validateStaticData = (values) => {
    const errors = {};
    if (!values.description) {
        errors.description = ['Description is required'];
        return errors;
    }
};

const validateSimpleStaticData = (values) => {
    const errors = {};
    if (!values.id) {
        errors.id = ['Identifier is required'];
        return errors;
    }
};

//ALL
export const BaseFilter = (props) => (
    <Filter {...props}>
        <RATextInput label="Search" source="q" alwaysOn />
    </Filter>
);
//ALL
export const FacultyFilter = (props) => (
    <Filter {...props}>
        <RATextInput label="Search" source="q" alwaysOn />
        <BooleanInput label="Academic" source="isAcademic" alwaysOn />
        <BooleanInput label="Current" source="current" alwaysOn />
        <RATextInput label="Structure" source="structureId" alwaysOn />
    </Filter>
);
//ALL using "description"
export const ShowTitleByDescription = ({ record }) => {
    return <span>{record ? `"${record.description}"` : ''}</span>;
};
//ALL using "Title"
export const ShowTitleByTitle = ({ record }) => {
    return (
        <span>
            {record
                ? ` Qualification ID:${record.qualificationId}` +
                  `Title: ${record.Title}` +
                  `Title: ${record.Title}`
                : ''}
        </span>
    );
};

export const ShowTitleByLowerTitle = ({ record }) => {
    return <span>{record ? `"${record.title}"` : ''}</span>;
};

export const ShowTitleById = ({ record }) => {
    return <span>{record ? `"${record.id}"` : ''}</span>;
};

export const ShowTitleByCode = ({ record }) => {
    return <span> {record ? `"${record.code}"` : ''} </span>;
};

export const ShowTitleByLowerName = ({ record }) => {
    return <span>{record ? `"${record.name}"` : ''}</span>;
};

export const CourseInstanceHeading = ({ record }) => {
    return <span>{record ? `"Course Instance ${record.id}"` : ''}</span>;
};

//Faculty/Group/SubGroup Lists
export const BaseListWithCurrent = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList {...props} filters={<BaseFilter />}>
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="Title" />
                    <TextField source="description" />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const BaseList = (props) => (
    <SwList {...props} filters={<BaseFilter />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Title" />
            <TextField source="description" />
        </Datagrid>
    </SwList>
);

export const IdTitleList = (props) => (
    <SwList {...props} filters={<BaseFilter />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Title" />
        </Datagrid>
    </SwList>
);

export const LowerTitleCurrentList = (props) => (
    <SwList {...props} filters={<BaseFilter />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="title" />
            <BooleanField source="current" />
        </Datagrid>
    </SwList>
);

// SimpleStaticData
export const SimpleStaticDataCreate = (props) => (
    <Create {...props}>
        <SimpleForm validate={validateSimpleStaticData}>
            <TextInput source="id" disabled />
        </SimpleForm>
    </Create>
);

export const SimpleStaticDataEdit = (props) => (
    <Edit title={<ShowTitleByDescription />} {...props}>
        <SimpleForm validate={validateSimpleStaticData}>
            <TextInput source="id" disabled />
            <TextInput source="created_at" disabled />
            <TextInput source="updated_at" disabled />
        </SimpleForm>
    </Edit>
);

export const SimpleStaticDataShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
//StaticData
export const StaticDataCreate = (props) => (
    <Create {...props}>
        <SimpleForm validate={validateStaticData}>
            <TextInput source="description" />
            <BooleanInput source="current" />
        </SimpleForm>
    </Create>
);

export const StaticDataEdit = (props) => (
    <Edit title={<ShowTitleByDescription />} {...props}>
        <SimpleForm validate={validateStaticData}>
            <TextInput source="id" disabled />
            <TextInput source="description" />
            <BooleanInput source="current" />
            <TextInput source="created_at" disabled />
            <TextInput source="updated_at" disabled />
        </SimpleForm>
    </Edit>
);

export const StaticDataShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="description" />
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
//StaticDataWithCode
export const StaticWithCodeCreate = (props) => (
    <Create {...props}>
        <SimpleForm validate={validateStaticDataWithCode}>
            <TextInput source="Title" />
            <TextInput source="description" />
            <BooleanInput source="current" />
        </SimpleForm>
    </Create>
);

const required =
    (message = 'Required') =>
    (value) =>
        value ? undefined : message;
const validateTitle = [required];

export const StaticWithCodeEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit {...props} title={<ShowTitleByDescription />}>
                <SimpleForm
                    validate={validateStaticDataWithCode}
                    toolbar={<EditToolbar />}
                >
                    <TextInput source="id" disabled />
                    <TextInput source="Title" />
                    <TextInput source="description" />
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const StaticWithCodeShow = (props) => (
    <Show {...props} title={<ShowTitleByDescription />}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Title" />
            <TextField source="description" />
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);

//Test methods: refactored to
export const ComposedStaticWithCodeShow = (props) => (
    <Show {...props} title={<ShowTitleByDescription />}>
        <CompesedInner {...props} />
    </Show>
);

export const CompesedInner = (props) => (
    <div>
        <TextField source="id" />
        <TextField source="Title" />
        <TextField source="description" />
        <BooleanField source="current" />
        <TextField source="created_at" />
        <DateField source="updated_at" />
    </div>
);

//StaticDataWithCode without Description (Title, current)
export const StaticWithCodeNoDescriptionCreate = (props) => (
    <Create {...props}>
        <SimpleForm validate={validateStaticDataWithCode}>
            <TextInput source="Title" />
            <BooleanInput source="current" />
        </SimpleForm>
    </Create>
);

export const StaticWithCodeNoDescriptionEdit = (props) => (
    <Edit {...props} title={<ShowTitleByTitle />}>
        <SimpleForm validate={validateStaticDataWithCode}>
            <TextInput source="id" disabled />
            <TextInput source="Title" />
            <BooleanInput source="current" />
            <TextInput source="created_at" disabled />
            <TextInput source="updated_at" disabled />
        </SimpleForm>
    </Edit>
);

export const StaticWithCodeNoDescriptionShow = (props) => (
    <Show {...props} title={<ShowTitleByTitle />}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Title" />
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);

const AddressField = ({ record = {} }) => (
    <span>
        {record.address1} {record.address2} {record.address3} {record.postcode}
    </span>
);
AddressField.defaultProps = { label: 'Address' };

//Test: attempt to solve the address in CampusLocation
export const AddressShow = (props) => (
    <Show {...props}>
        <Datagrid>
            <AddressField source="address1" />
            <AddressField source="address2" />
            <AddressField source="postcode" />
        </Datagrid>
    </Show>
);
